import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { MicroSiteLeadData } from '.';

interface IAddMicroSiteData {
	mutate: UseMutateFunction<MicroSiteLeadData, Error, MicroSiteLeadData, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useAddSiteLeadBySS = (): IAddMicroSiteData => {
	const postAddSiteLeadBySSData = async (siteLeadFormData: MicroSiteLeadData): Promise<MicroSiteLeadData> => {
		return await APIService.postData<MicroSiteLeadData>(APICONFIG.ADD_MICRO_SITE, siteLeadFormData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: postAddSiteLeadBySSData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
